import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updateGeneralPoliticsSchema = z.object({
  company: z.object({
    printer_machine_id: optionSchema.optional(),
    time_zone_id: optionSchema.optional(),
    price_survey_mode: optionSchema.optional(),
    allowed_establishment_flags: z.array(optionSchema).optional(),
    establishment_blocked_flags_mode: optionSchema.optional(),
    usage_declaration_mode: optionSchema.optional(),
    tracker_integration_mode: optionSchema.optional(),
    create_usage_declaration_mode: optionSchema.optional(),
    update_equipment_log_reason_requirement: optionSchema.optional(),
    update_user_log_reason_requirement: optionSchema.optional(),
    equipment_driver_license_requirements_for_consumptions: optionSchema.optional(),
    card_activation_mode: optionSchema.optional(),
    require_bill_review: optionSchema.optional(),
    government_allocation_currency_restricted: optionSchema.optional(),
  }),
  cards_quota: z.string().optional()
})

export type UpdateGeneralPoliticsSchema = z.infer<typeof updateGeneralPoliticsSchema>
